import {EntityData, field} from "@fedeltapointofsale/data-client";

export class GroupedOutletCustomData extends EntityData<GroupedOutletCustomData> {

    public static readonly TYPE_CUSTOM_OBJECT = "CUSTOMOBJECT";

    public static readonly TYPE_OUTLET = "OUTLET";

    @field type: string;
    @field group: string;
    @field id: number;
    @field name: string;
}
